export default function Hero() {
  return (
    <section id="hero" className="relative flex min-h-[640px] items-center overflow-hidden md:min-h-[680px]">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=warm%20cream%20and%20coral%20orange%20stylized%20abstract%20illustration%20of%20open%20comic%20book%20pages%20floating%20with%20comic%20panels%20and%20ink%20splashes%2C%20soft%20rounded%20organic%20shapes%2C%20deep%20pine%20green%20accents%2C%20editorial%20manga%20inspired%20art%2C%20inviting%20and%20modern%2C%20high%20detail&width=1600&height=900&seq=hero-2026&orientation=landscape"
          alt="漫蛙漫画温暖风格的漫画阅读插画背景"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/55 via-foreground-950/35 to-foreground-950/65"></div>
      </div>

      <div className="relative z-10 mx-auto w-full max-w-7xl px-4 py-24 text-center md:px-6">
        <span className="inline-flex items-center gap-2 rounded-full bg-background-50/15 px-4 py-1.5 text-sm font-medium text-background-50 backdrop-blur">
          <i className="ri-flashlight-fill text-secondary-300" aria-hidden="true"></i>
          章节直达 · 分卷阅读 · 高效追更
        </span>

        <h1 className="mx-auto mt-6 max-w-3xl font-heading text-4xl font-black leading-tight text-background-50 md:text-6xl">
          想看的章节，<span className="text-secondary-300">一戳即达</span>
        </h1>

        <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-background-100 md:text-lg">
          漫蛙漫画支持跳章、目录跳转与分卷阅读。不用从头翻到尾，想看的章节一键直达，
          进度随心跳跃，长篇漫画也能轻松管理，追更效率直接翻倍。
        </p>

        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <a
            href="#recommend"
            className="inline-flex w-full items-center justify-center whitespace-nowrap rounded-full bg-primary-500 px-8 py-3 text-sm font-semibold text-background-50 transition-all hover:bg-primary-600 hover:shadow-lg sm:w-auto"
          >
            去追热门作品
            <i className="ri-arrow-right-line ml-2" aria-hidden="true"></i>
          </a>
          <a
            href="#features"
            className="inline-flex w-full items-center justify-center whitespace-nowrap rounded-full bg-background-50/15 px-8 py-3 text-sm font-semibold text-background-50 backdrop-blur transition-colors hover:bg-background-50/25 sm:w-auto"
          >
            了解阅读功能
          </a>
        </div>

        <div className="mx-auto mt-12 grid max-w-2xl grid-cols-3 gap-4">
          {[
            { num: '1.2万+', label: '连载作品' },
            { num: '32万+', label: '章节目录直达' },
            { num: '9.4', label: '读者平均评分' },
          ].map((s) => (
            <div
              key={s.label}
              className="rounded-2xl border border-background-50/20 bg-background-50/10 px-3 py-4 text-center backdrop-blur"
            >
              <div className="font-heading text-2xl font-bold text-background-50 md:text-3xl">{s.num}</div>
              <div className="mt-1 text-xs text-background-200 md:text-sm">{s.label}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 text-background-50/80">
        <i className="ri-arrow-down-line animate-bounce text-xl" aria-hidden="true"></i>
      </div>
    </section>
  );
}